/* jslint esversion: 6 */
/**
 * Secondary Fixed
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	$window            : $(window),
	$wpadminbar        : $('#wpadminbar'),
	$fixedContainer    : $('.secondary, .secondary-like'),
	$fixedItem         : $('.secondary__inner, .secondary-like__inner'),
	fixedThreshold     : 960,
	fixedStart         : 0,
	fixedEnd           : 0,
	windowScrollTop    : 0,
};

function init() {

	if (s.$fixedContainer.length && s.$fixedItem.length) {

		events();
	}
}

function events() {

	s.$window.on('load resize scroll', function() {

		if (parseFloat(s.$fixedItem.css('height')) >= s.$window.height()) {

			s.$fixedContainer.removeClass('secondary--fixed');
			s.$fixedContainer.removeClass('secondary--absolute');
		}
		else {

			s.windowScrollTop = s.$window.scrollTop(); // window.pageYOffset;

			s.wpadminbarHeight = s.$wpadminbar.length ? parseFloat(s.$wpadminbar.css('height')) : 0;

			s.fixedContainerHeight = s.$fixedContainer.length ? parseFloat(s.$fixedContainer.css('height')) : 0;
			s.fixedItemHeight      = s.$fixedItem.length ? parseFloat(s.$fixedItem.css('height')) : 0;

			s.fixedStart = s.$fixedContainer.offset().top - s.wpadminbarHeight;
			s.fixedEnd   = s.fixedStart + s.fixedContainerHeight - s.fixedItemHeight;

			if (s.$window.width() < s.fixedThreshold) {
				s.$fixedContainer.removeClass('secondary--fixed');
				s.$fixedContainer.removeClass('secondary--absolute');
			}
			else {

				if (s.windowScrollTop <= s.fixedStart) {
					s.$fixedContainer.removeClass('secondary--fixed');
					s.$fixedContainer.removeClass('secondary--absolute');
				} else {

					if (s.windowScrollTop >= s.fixedStart && s.windowScrollTop < s.fixedEnd) {
						s.$fixedContainer.addClass('secondary--fixed');
					}
					else {
						s.$fixedContainer.removeClass('secondary--fixed');
					}

					if (s.windowScrollTop >= s.fixedEnd) {
						s.$fixedContainer.addClass('secondary--absolute');
					}
					else {
						s.$fixedContainer.removeClass('secondary--absolute');
					}
				}
			}
		}
	});
}

export {init as default};
